import React from 'react'
import { BrowserViewDataAsync, VPQueryAsync, RecordNumbers } from './fetchData';
import { Loading } from './Loading';
import cn from 'classnames'
import DetailWindow from './DetailWindow';
import TitleWindow from './TitleWindow';
import $ from "jquery";
import "abortcontroller-polyfill/dist/polyfill-patch-fetch"
import {PageView} from '../components/Tracking';

export default class BrowserView extends React.Component {

	constructor(props) {
		super(props);
		const viewID = props.match.params.id
		const datasetID = props.match.params.datasetID
		const Note = props.location.state.ViewNote
		const VPDatasetID = props.location.state.VPDatasetID
		const FieldArray = props.location.state.FieldArray
		const DetailFields = props.location.state.DetailFields
		const TitleViewField = props.location.state.TitleViewField
		const appURL = props.location.state.appURL
		const ProductName = props.match.params.ProductName
		let DetailViews = [];
		let numDetails = 0;
		let DetailWindowsPanelClass = ""
		if (props.location.state.DetailViews !== ""){
			DetailViews = props.location.state.DetailViews;
			numDetails = DetailViews.length
		}
		if (numDetails === 0){
			DetailWindowsPanelClass = cn("zero-width")
		}
		this.state = {
		  BrowserName: '',
		  DetailWindowsPanelClass: DetailWindowsPanelClass,
		  datasetID: datasetID,
		  RecordsSelectedInDetailView: [],
		  browserViewID: viewID,
		  FieldArray: FieldArray,
		  DetailFields: DetailFields,
		  ProductName: ProductName,
		  VPDatasetID: VPDatasetID,
		  URL: '',
		  appURL: appURL,
		  numDetails: numDetails,
		  WebsiteURL: "https://www.thevantagepoint.com/",
		  loading: true,
		  mainPanelSelection: [],
		  sheetNote: Note,
		  fullScreen: false,
		  DetailViews: DetailViews,
		  TitleViewField: TitleViewField
		};

		this.toggleFullscreen = this.toggleFullscreen.bind(this)
	}
	fetchData(appURL, datasetID, browserViewID){
		BrowserViewDataAsync(appURL, datasetID, browserViewID)
		.then((data) => {
			const BrowserResults = data
			for (var sheet in BrowserResults){
				var dataObject = BrowserResults[sheet]
			}
			var URL = 'https://' + dataObject.URL[0];
			if (this.mounted){
				this.setState({
					BrowserName: dataObject.ViewName,
					URL: URL,
					loading: false
				})
			}
		})
		
	}
	SelectRecords = (e) => {
		let mainPanelSelection = {}
		const message = String(e.data)

		//need to get starting position SelectRecordSet: + Dataset.ID.length-2 + 1
		if (message.search("SelectRecordSet:") >= 0){
			mainPanelSelection = {
				bSelection: true,
				browserSelectString: "RecordSet",
				selectedIDs: message.slice(message.search("SelectRecordSet:") + "SelectRecordSet:".length + this.state.VPDatasetID.length - 2 + 1),
			}
			if (this.mounted){
				this.setState({
					mainPanelSelection: mainPanelSelection
				})
			}
		}
		else if (message.search("ShowRecords:") >= 0){
			mainPanelSelection = {
				bSelection: true,
				browserSelectString: "Records",
				selectedIDs: message.slice(message.search("ShowRecords:") + 12),
			}
			if (this.mounted){
				this.setState({
					mainPanelSelection: mainPanelSelection
				})
			}
		}
		else if (message.search("ShowClusterInTitleView:") >= 0){
			mainPanelSelection = {
				bSelection: true,
				browserSelectString: "Cluster",
				selectedIDs: message.slice(message.search("ShowClusterInTitleView:") + 23)
			}
			if (this.mounted){
				this.setState({
					mainPanelSelection: mainPanelSelection
				})
			}
		}
		else if (message.search("QueryRecordNumbers:") >= 0){
			
			let strQuery = message.slice(message.search("QueryRecordNumbers:") + 19)
			let datasetID = this.state.datasetID;
			let appURL = this.state.appURL;
			RecordNumbers(appURL, datasetID, strQuery, this.abortController.signal)
			.then((data) => {
				mainPanelSelection = {
					bSelection: true,
					browserSelectString: "Records",
					selectedIDs: data.join(":") + ":"
				}
				if (this.mounted){
					this.setState({
						mainPanelSelection: mainPanelSelection
					})
				}
			})
		}
		else if (message.search("VPQuery:") >=0 ){
			let vpQuery = message.slice(message.search("VPQuery:") + 9)
			let chartNum = message.slice(message.search("VPQuery:") + 8, 9)

			VPQueryAsync(this.state.appURL, this.state.datasetID, vpQuery, chartNum, this.abortController.signal).then((data) => {
				document.querySelector('iframe').contentWindow.postMessage(JSON.stringify(data), this.state.appURL)
				/*if (this.mounted){
					this.setState({
						mainPanelSelection: mainPanelSelection
					})
				}*/
			})
		}
		else {
			mainPanelSelection = this.state.mainPanelSelection
		}
	  };
	componentDidMount(){
		this.mounted = true;
		this.fetchData(this.state.appURL, this.state.datasetID, this.state.browserViewID)
		window.addEventListener('message', this.SelectRecords);
		PageView();

	}
	componentDidUpdate(prevProps, prevState){
		let newLocation = prevProps.history.location.pathname
		let ViewID = newLocation.substring(newLocation.search("0x"))
		//new view id
		if (ViewID !== prevState.browserViewID){
			let DetailViews = [];
			let numDetails = 0;
			let DetailWindowsPanelClass = "";
			if (this.props.location.state.DetailViews !== ""){
				DetailViews = this.props.location.state.DetailViews;
				numDetails = DetailViews.length
			}
			if (numDetails === 0){
				DetailWindowsPanelClass = cn("zero-width")
			}
			this.setState({
				BrowserName: '',
				DetailWindowsPanelClass: DetailWindowsPanelClass,
				browserViewID: ViewID,
				loading: true,
				sheetNote: this.props.location.state.ViewNote,
				mainPanelSelection: [],
				numDetails: numDetails,
				DetailViews: DetailViews
			})
			
			this.fetchData(this.state.appURL, this.state.datasetID, ViewID)
		}

  
	}
	componentWillUnmount(){
		this.mounted = false;
		this.abortController.abort();
	}
	abortController = new window.AbortController();
	toggleFullscreen(state){
		if (state){
			$(".MainPanel").removeClass("FullScreen");
		}
		else {
			$(".MainPanel").addClass("FullScreen");
		}
		this.setState({
			fullScreen: !state
		})

	}
	openWebsite(){

	}
	getDetailSelection = (dataFromChild) => {
		this.setState({
			RecordsSelectedInDetailView: dataFromChild
		})
	}
	render() {
		
		const {
			fullScreen,
			DetailViews,
			browserViewID,
			datasetID,
			mainPanelSelection,
			WebsiteURL,
			TitleViewField,
			FieldArray,
			DetailFields,
			appURL,
			DetailWindowsPanelClass
		} = this.state;
		return(
		<div className="FillWindow">
			{this.state.loading === true
			? <Loading />
			:<div>
				<div className="flex-grid">
					<div className="TitleWindowPanel">
						<TitleWindow appURL={appURL} id={this.state.browserViewID} datasetID={this.state.datasetID} mainPanelSelection={mainPanelSelection} detailSelection={this.state.RecordsSelectedInDetailView} Note={this.state.sheetNote} callbackFromParent={this.getTitleSelection} DefaultField={TitleViewField} FieldArray={FieldArray}></TitleWindow>
					</div>
					<div className="MainPanel">
						<div className="viewFullscreenContainer" title="View Fullscreen"><div className="viewFullscreenButton" title="View Fullscreen" onClick={() => this.toggleFullscreen(fullScreen)}></div></div>          
						<iframe id="iframe" title={this.state.BrowserName} data-datasetid={this.state.datasetID} data-url={this.state.appURL} src={this.state.URL} style={{height: '100%', width: '100%'}}/>
						<div id="CursorControl" className="DefaultCursor"></div>
					</div>
					<div className={cn(DetailWindowsPanelClass, "DetailWindowPanel")}>
						{
						DetailViews.map((value, num) => {
							return (
								<DetailWindow appURL={appURL} key={num} id={browserViewID} numDetails={this.state.numDetails} datasetID={datasetID} mainPanelSelection={mainPanelSelection} DefaultField={value} callbackFromParent={this.getDetailSelection} FieldArray={FieldArray} DetailFields={DetailFields}></DetailWindow>
							)
						})}
					</div>
				</div>    
			</div>
			}
		</div>
		)    
	}
}